import React, {Fragment, useState, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Explanation_text, GoogleLogin, Video} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {connect} from 'react-redux';

function Smtp_setup_popup(props){
  const[provider, setProvider]=useState('generic');
  const[warning, setWarning]=useState(false);
  let first_time=useRef(false);

  function onSubmit(params){
    let cont=true;
    if(params.imap_server==undefined || params.imap_server==='' || params.imap_port==undefined || params.imap_port===''){cont=false; if(window.confirm("Not adding proper IMAP settings means no inbound emails will be received. We therefore won't be able to know if an email has bounced")){cont=true;}}
    if(cont==true){
      if(props.smtp_login_id=='NEW'){props.createSmtpLogin(params);}
      else{ props.updateSmtpLogin(params, props.smtp_login_id); }
    }
  }

  let initial_data={}
  if(props.smtp_login_id){
    for(let s of props.gmail.smtp_logins){
      if(s.id==props.smtp_login_id){if(first_time.current==true){first_time.current=false; setProvider((s.provider=='outlook_api')?'outlook':s.provider);} initial_data={...s}}
    }
  }

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={{main_inbox_folder:'Inbox', main_sent_folder:'Sent', ...initial_data}}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}  always_open title='smtp_setup_popup_title' content={
          <div style={{width:'95vw', maxWidth:'600px', height:'450px', marginTop:'20px'}}>
            <Grid container>
              <Grid item xs={12} style={{marginBottom:'0px'}}><Select title="smtp_setup_provider_label" name="provider" select_data={[{id:'gmail', name:'Gmail'}, {id:'outlook', name:'Outlook'}, {id:'generic', name:'Generic'}]}/></Grid>
              {(provider!=undefined && provider!='')?<Grid item xs={12}><Video style={{width:'100%', height:'180px', marginBottom:'0px', marginTop:'10px'}} video={(provider=='gmail')?'GMAIL_INTRO':(provider=='generic')?'GENERIC_EMAIL_INTRO':'OUTLOOK_INTRO'} autoplay/></Grid>:null}
              {<Field name='provider'>{(f_provider)=>(f_provider.input.value=='')?
                <div style={{width:'100%', marginTop:'100px', marginBottom:'100px'}}>
                  <Typography style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Explanation_text text='smtp_setup_explanation_short_text'/></Typography>
                </div>
                :(provider=='outlook' || provider=='outlook_api')?
                <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'30px', marginBottom:'0px'}}><Button style={{backgroundColor:'white'}} variant='contained' onClick={()=>{window.location.href='/login/outlook'}}><img src='/images/outlook.png' style={{width:'40px', marginLeft:'-10px', marginRight:'5px', marginTop:'-7px', marginBottom:'-7px'}}/>Connect</Button></div>
                :
                <Fragment>
                    <Grid item xs={12}><Text title="Connection name" name="connection_name"/></Grid>
                    <Grid item xs={6} sm={6} style={{marginBottom:'5px'}}><Text title="smtp_setup_username_label" name="username"/></Grid>
                    <Grid item xs={6} sm={6} style={{marginBottom:'5px'}}><Text type='password' title="smtp_setup_password_label" name="password"/></Grid>
                    <Grid item xs={4} sm={4}><Text disabled={(provider=='gmail' || provider=='outlook')?true:false} title="smtp_setup_smtp_server_only_label" name="smtp_server"/></Grid>
                    <Grid item xs={2} sm={2}><Text disabled={(provider=='gmail' || provider=='outlook')?true:false} title="smtp_setup_smtp_port_label" name="smtp_port"/></Grid>
                    <Grid item xs={4} sm={4}><Text disabled={(provider=='gmail' || provider=='outlook')?true:false} title="smtp_setup_imap_server_only_label" name="imap_server"/></Grid>
                    <Grid item xs={2} sm={2}><Text disabled={(provider=='gmail' || provider=='outlook')?true:false} title="smtp_setup_imap_port_label" name="imap_port"/></Grid>
                    <Grid item xs={6} sm={6} style={{marginTop:'5px'}}><Text  title="smtp_setup_inbox_folder_label" name="main_inbox_folder"/></Grid>
                    <Grid item xs={6} sm={6} style={{marginTop:'5px'}}><Text  title="smtp_setup_sent_folder_label" name="main_sent_folder"/></Grid>
                </Fragment>
              }</Field>}
            </Grid>
            <Field name='connection_name'>{(f_c_name)=>
            <Field name='smtp_server'>{(f_s_serv)=>
              <Field name='smtp_port'>{(f_s_port)=>
                <Field name='imap_server'>{(f_i_serv)=>
                  <Field name='imap_port'>{(f_i_port)=>
                    <Field name='main_inbox_folder'>{(f_main_inbox_label)=>
                      <Field name='main_sent_folder'>{(f_main_sent_label)=>
            <Field name='provider'>{(f)=>{if(provider!=f.input.value){setProvider(f.input.value); window.setTimeout(function(){if(f.input.value=='gmail'){f_c_name.input.onChange('Gmail'); f_s_serv.input.onChange('smtp.gmail.com'); f_s_port.input.onChange('587'); f_i_serv.input.onChange('imap.gmail.com'); f_i_port.input.onChange('993'); f_main_inbox_label.input.onChange('INBOX'); f_main_sent_label.input.onChange('[Gmail]/Sent Mail');}else if(f.input.value=='outlook'){f_c_name.input.onChange('Outlook'); f_s_serv.input.onChange('smtp.office365.com'); f_s_port.input.onChange('587'); f_i_serv.input.onChange('outlook.office365.com'); f_i_port.input.onChange('993'); f_main_inbox_label.input.onChange('Inbox'); f_main_sent_label.input.onChange('Sent');}else{f_c_name.input.onChange('Custom'); f_s_serv.input.onChange(''); f_i_serv.input.onChange(''); f_i_port.input.onChange(''); f_s_port.input.onChange(); f_main_inbox_label.input.onChange('INBOX'); f_main_sent_label.input.onChange('Sent Mail');}},100); return(null)}}}</Field>
          }</Field>}</Field>}</Field>}</Field>}</Field>}</Field>}</Field>
          </div>
        }/>
        </form>
      )}
    </Form>
  );
}


export default connect(ss, dd)(Smtp_setup_popup);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
    createSmtpLogin:(params)=>{dispatch({type:'REQUEST_CREATE_SMTP_LOGIN', payload:params})},
    updateSmtpLogin:(params, id)=>{dispatch({type:'REQUEST_UPDATE_SMTP_LOGIN', payload:params, id:id})}
  }
}
